import { Link, graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import { Container } from "react-bootstrap";
import SonestaLogo from "../../../svg/SonestaLogo.svg";
import { getParagraph } from "../../../utils/paragraphHelpers";
import OldBrandBar from "../OldBrandBar/BrandBar";
import { footerBrandContainer } from "./Footer.module.scss";
import {
  CopyRight,
  CopyrightCol,
  CopyrightRow,
  FooterWrapper,
} from "./FooterHelpers";
import FooterLinks from "./FooterLinks/FooterLinks";
import { IFooterProps } from "./FooterProps";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const Footer: React.FC<IFooterProps> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  const data = useStaticQuery(graphql`
    query {
      site: rlhsite(machine_name: { eq: "sonesta" }) {
        id
        relationships {
          footerItems: field_footer {
            type: __typename
            ...ParagraphFooterCta
            ...ParagraphMerchandisingBlock
            ... on paragraph__footer_item {
              field_footer_group
              field_footer_link {
                title
                url
              }
            }
          }
        }
      }
    }
  `);
  const _footerLinks = data.site.relationships.footerItems;
  const footerMerchandisingBlock = _footerLinks
    ? _footerLinks.map(getParagraph)
    : [];

  return (
    <FooterWrapper>
      <Container fluid="sm">
        <FooterLinks {..._footerLinks} />
        <hr className="d-none d-lg-block mt-4 mb-4" />

        <div className={footerBrandContainer}>
          <div className="icon-container">
            {isMobileOnly ? (
              <div className="sonesta-footer-logo mobile-view">
                <SonestaLogo />
              </div>
            ) : (
              <svg className="sonesta-footer-logo desktop-view">
                <use xlinkHref="/svg/footer/SonestaFooterXL.svg#SonestaFooterLogoXL"></use>
              </svg>
            )}

            <div className="row">
              <div className="col" id="travelpass-col">
                <div id="travelpass-container">
                  <Link to="/travel-pass">
                    <svg className="travelpass" width={159.95} height={87.62}>
                      <use xlinkHref="/svg/footer/Travelpass.svg#Travelpass"></use>
                    </svg>
                  </Link>
                </div>
              </div>
              <div id="col-brand">
                <OldBrandBar footer={true} />
              </div>
            </div>
            <Link to="/travel-pass">
              <svg className="travelpass-footer-logo">
                <use xlinkHref="/svg/footer/Travelpass.svg#Travelpass"></use>
              </svg>
            </Link>
          </div>
        </div>

        <hr className="d-none d-lg-block mt-4 mb-4" />
        {props.showMerchandisingBlock !== undefined
          ? props.showMerchandisingBlock
            ? footerMerchandisingBlock
            : null
          : footerMerchandisingBlock}
        <hr className="d-none d-lg-block" />
        <CopyrightRow>
          <CopyrightCol>
            <CopyRight className="text-center text-lg-left">
              © {new Date().getFullYear()} Sonesta International Hotels
              Corporation. All Rights Reserved.
            </CopyRight>
          </CopyrightCol>
        </CopyrightRow>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
